module.exports = "<div class=\"popup-container\">\r\n  <div class=\"popup-wrapper\" (click)=\"close()\"></div>\r\n  <div class=\"popup\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5>Personal Information</h5>\r\n    <div class=\"popup-line-div\"></div>\r\n    <personal-information (onSave)=\"onSave()\">loading...</personal-information>\r\n    <button *ngIf=\"showClose\" class=\"btn text-center\" (click)=\"close()\">Close</button>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/message/profile-popup/profile-popup.component.html
// module id = 924
// module chunks = 0